"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateKeyedEntryFields = exports.mapZodTypeName = exports.getInputBaseFields = exports.getLowestNodeIdIfMultiple = exports.copyNodeConfiguration = exports.updateArtifactSlug = exports.getAllInputDependencyNodesForNode = exports.getAllInputsForArtifact = exports.getDirectInputsForArtifact = exports.checkEdges = exports.getTargetNodes = exports.getSourceNodes = exports.getNodeById = exports.getTapeById = exports.getInputTapeIds = exports.isValidBaseField = void 0;
const _ = __importStar(require("lodash"));
const zod_1 = require("zod");
const common_1 = require("@finley-technologies/common");
const isValidBaseField = (params) => {
    const { baseFields, targetField, targetTypes } = params;
    const targetBaseField = baseFields.find(({ field }) => field === targetField);
    if (!targetBaseField) {
        return false;
    }
    return targetTypes.some((type) => targetBaseField.type === type);
};
exports.isValidBaseField = isValidBaseField;
const getInputTapeIds = ({ tapeId, graph, }) => {
    return graph.dataTapeDependencies
        .filter(({ outputArtifactId }) => outputArtifactId === tapeId)
        .map(({ inputArtifactId }) => inputArtifactId);
};
exports.getInputTapeIds = getInputTapeIds;
const getTapeById = ({ tapeId, graph, }) => {
    return graph.dataTapes.find(({ id }) => id === tapeId);
};
exports.getTapeById = getTapeById;
const getNodeById = ({ tapeBuilderNodeId, nodes, }) => {
    const filtered = nodes.filter(({ metadata }) => metadata.tapeBuilderNodeId === tapeBuilderNodeId);
    (0, common_1.finleyAssert)(filtered.length === 1, `found [${filtered.length}] nodes matching [id:${tapeBuilderNodeId}]`);
    return filtered[0];
};
exports.getNodeById = getNodeById;
const getSourceNodes = ({ node, graph, }) => {
    const { nodes, edges } = graph;
    const srcNodes = edges
        .filter(({ target }) => target === node.metadata.tapeBuilderNodeId)
        .map(({ source }) => (0, exports.getNodeById)({ tapeBuilderNodeId: source, nodes }));
    return srcNodes;
};
exports.getSourceNodes = getSourceNodes;
const getTargetNodes = ({ node, graph, }) => {
    const { nodes, edges } = graph;
    const targetNodes = edges
        .filter(({ source }) => source === node.metadata.tapeBuilderNodeId)
        .map(({ target }) => (0, exports.getNodeById)({ tapeBuilderNodeId: target, nodes }));
    return targetNodes;
};
exports.getTargetNodes = getTargetNodes;
// validates that the given node has given number of inputs and outputs.
// return an array of errors.
const checkEdges = ({ friendlyName, inputs, outputs, isAllowedInputNode, minInputs, maxInputs, minOutputs, maxOutputs, }) => {
    const errors = [];
    if (inputs.length < minInputs || inputs.length > maxInputs) {
        errors.push(`${friendlyName} node must have between ${minInputs} and ${maxInputs} input nodes. Found: ${inputs.length}`);
    }
    inputs.forEach(({ node: inputNode, uiNode: inputUiNode }) => {
        if (!isAllowedInputNode(inputUiNode)) {
            const inputFriendlyName = inputUiNode.getFriendlyName(inputNode);
            errors.push(`${friendlyName} node cannot have ${inputFriendlyName} node as input`);
        }
    });
    if (outputs.length < minOutputs || outputs.length > maxOutputs) {
        errors.push(`${friendlyName} node must have between ${minOutputs} and ${maxOutputs} output nodes. Found: ${outputs.length}`);
    }
    return errors;
};
exports.checkEdges = checkEdges;
const getDirectInputsForArtifact = (params) => {
    const { targetArtifactId, dataTapes, dataTapeDependencies } = params;
    const graph = { dataTapes, dataTapeDependencies };
    const inputArtifactIds = (0, exports.getInputTapeIds)({ graph, tapeId: targetArtifactId });
    const inputArtifacts = inputArtifactIds.map((tapeId) => {
        const inputArtifact = (0, exports.getTapeById)({ graph, tapeId });
        (0, common_1.finleyAssert)(inputArtifact, `inputArtifact must exist for [tapeId:${tapeId}]`);
        return inputArtifact;
    });
    return inputArtifacts;
};
exports.getDirectInputsForArtifact = getDirectInputsForArtifact;
const getAllInputsForArtifact = (params) => {
    const { dataTapes, dataTapeDependencies } = params;
    const directInputs = (0, exports.getDirectInputsForArtifact)(params);
    const recursiveInputs = directInputs.flatMap((input) => (0, exports.getAllInputsForArtifact)({
        targetArtifactId: input.id,
        dataTapes,
        dataTapeDependencies,
    }));
    return Array.from(new Set([...directInputs, ...recursiveInputs]));
};
exports.getAllInputsForArtifact = getAllInputsForArtifact;
const getAllInputDependencyNodesForNode = (node, graph) => {
    const inputNodes = (0, exports.getSourceNodes)({ node, graph });
    return inputNodes.reduce((acc, inputNode) => {
        acc.push(inputNode);
        const inputNodesForInputNode = (0, exports.getSourceNodes)({
            node: inputNode,
            graph,
        });
        if (inputNodesForInputNode.length) {
            const inputNodesForInputNodeDependencies = (0, exports.getAllInputDependencyNodesForNode)(inputNode, graph);
            inputNodesForInputNodeDependencies.forEach((dependency) => {
                // prevent duplicate dependencies being added if graphs diverged and then remerged
                if (!acc.find(({ metadata: { tapeBuilderNodeId } }) => dependency.metadata.tapeBuilderNodeId === tapeBuilderNodeId)) {
                    acc.push(dependency);
                }
            });
        }
        return acc;
    }, []);
};
exports.getAllInputDependencyNodesForNode = getAllInputDependencyNodesForNode;
const updateArtifactSlug = (currentSlug, suggestedSerialNumber) => {
    const regex = /_[\da-f]{6,}$/;
    // If the current slug ends with and underscore followed by six or more hex digits
    if (regex.test(currentSlug)) {
        // Replace them
        return currentSlug.replace(regex, `_${suggestedSerialNumber}`);
    }
    // Else, append them
    return `${currentSlug}_${suggestedSerialNumber}`;
};
exports.updateArtifactSlug = updateArtifactSlug;
// Copy/paste: a deep copy of `nodeToCopy`'s configuration with its artifact
// slug re-serialled. Callers overwrite any fields that must not be copied.
const copyNodeConfiguration = ({ nodeToCopy, isNode, nodeType, suggestedSerialNumber, }) => {
    (0, common_1.finleyAssert)(isNode(nodeToCopy), `node must be a ${nodeType} node`);
    const configuration = _.cloneDeep(nodeToCopy.configuration);
    configuration.artifactSlug = (0, exports.updateArtifactSlug)(configuration.artifactSlug, suggestedSerialNumber);
    return configuration;
};
exports.copyNodeConfiguration = copyNodeConfiguration;
// sorts the nodes by their tapeBuilderNodeId and returns the lowest one.
// this is used by callers to pick a single stable node id among multiple nodes.
const getLowestNodeIdIfMultiple = (nodes) => {
    return nodes.length > 1
        ? nodes.map(({ metadata }) => metadata.tapeBuilderNodeId).sort()[0]
        : null;
};
exports.getLowestNodeIdIfMultiple = getLowestNodeIdIfMultiple;
// The base fields of the direct input `inputArtifactSlug`, or the error
// explaining why they are unavailable.
const getInputBaseFields = ({ artifactInputs, inputArtifactSlug, tapeBuilder, errorPrefix, }) => {
    const artifactInput = artifactInputs.find((input) => input.artifactSlug === inputArtifactSlug);
    if (!artifactInput) {
        return {
            isValid: false,
            error: `${errorPrefix} cannot find [inputArtifact:${inputArtifactSlug}] listed as an input dependency.`,
        };
    }
    const tapeDefinitionResult = tapeBuilder.generateTapeDefinition(artifactInput.id);
    if (!tapeDefinitionResult.isValid || !tapeDefinitionResult.data) {
        return {
            isValid: false,
            error: `${errorPrefix} cannot get tape definition of [inputArtifact:${inputArtifactSlug}].`,
        };
    }
    return { isValid: true, baseFields: tapeDefinitionResult.data.baseFields };
};
exports.getInputBaseFields = getInputBaseFields;
const mapZodTypeName = (typeName) => {
    if (typeName instanceof zod_1.z.ZodString) {
        return 'string';
    }
    if (typeName instanceof zod_1.z.ZodNumber) {
        return 'float';
    }
    return (0, common_1.finleyAssertUnreachable)(typeName, `mapZodTypeName: typeName is not a ZodString or ZodNumber, found: ${typeName}`);
};
exports.mapZodTypeName = mapZodTypeName;
// Checks the input of a node that reads keyed values (covenants, org provided
// inputs) has the fields its `format` needs.
const validateKeyedEntryFields = ({ format, keys, recordShape, baseFields, errorPrefix, }) => {
    const errors = [];
    if (format === 'columnPerEntry') {
        // Column per entry - make sure each column we're pulling from is
        // present and has the right type.
        const valueType = (0, exports.mapZodTypeName)(recordShape.value);
        keys.forEach((key) => {
            if (!baseFields.some((bf) => bf.field === key && bf.type === valueType)) {
                errors.push(`${errorPrefix} expected to have [field:${key}] of [type:${valueType}]`);
            }
        });
    }
    else if (format === 'rowPerEntry') {
        // Row per entry - each row should adhere to the expected format.
        Object.entries(recordShape)
            .map(([key, val]) => ({
            fieldName: key,
            type: (0, exports.mapZodTypeName)(val),
        }))
            .forEach((field) => {
            const foundField = baseFields.find((baseField) => baseField.field === field.fieldName);
            if (!foundField) {
                errors.push(`${errorPrefix} tape definition is missing [field:${field.fieldName}].`);
            }
            else if (foundField.type !== field.type) {
                errors.push(`${errorPrefix} tape definition for [fieldName:${field.fieldName}] should be [type:${field.type}], but got [type:${foundField.type}].`);
            }
        });
    }
    else {
        (0, common_1.finleyAssertUnreachable)(format);
    }
    return errors;
};
exports.validateKeyedEntryFields = validateKeyedEntryFields;
//# sourceMappingURL=utils.js.map